import { get } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  actions: {
    retrieveRoles: () => get('/roles'),

    retrieveRolesForPersons: () => get('/rolesForPersons'),

    retrieveRolesForUsers: () => get('/rolesForUsers')
  }
};
